{
  "home": {
    "title": "Dashboard",
    "welcome": "Willkommen zurück, {{name}}",
    "guest": "Gast",
    "subtitle": "Das passiert heute mit Ihrem geistigen Eigentum.",
    "currentApplication": "Aktuelle Anmeldung",
    "applicationProgress": "Anmeldungsfortschritt",
    "noActiveApplications": "Keine aktiven Anmeldungen",
    "createFirst": "Erstellen Sie Ihre erste Markenanmeldung, um zu beginnen.",
    "quickActions": "Schnellaktionen",
    "resumeFiling": "Angebot & Zahlung",
    "resumeFilingDesc": "Angebot ansehen und bezahlen",
    "paymentHistory": "Zahlungsverlauf",
    "paymentHistoryDesc": "Belege und Rechnungen anzeigen",
    "contactSupport": "Support kontaktieren",
    "contactSupportDesc": "Hilfe von unserem Team erhalten",
    "lastUpdated": "Zuletzt aktualisiert: {{date}}",
    "newFiling": "Neue Markenprüfung",
    "viewAll": "Alle anzeigen",
    "continueFiling": "Angebot & Zahlung ansehen",
    "payAndFile": "Bezahlen & anmelden",
    "viewQuoteStatus": "Status anzeigen",
    "viewFilingStatus": "Anmeldestatus anzeigen",
    "activeFilings": "Aktive Anmeldungen",
    "actionRequired": "Aktion erforderlich",
    "protectedAssets": "Geschützte Vermögenswerte",
    "startProtecting": "Beginnen Sie mit einer kostenlosen Markenprüfung auf unserer Website. Sie erhalten innerhalb von 24 Stunden einen ausführlichen Bericht und ein von Anwälten bestätigtes Angebot — ohne Vorauszahlung.",
    "startNewApp": "Kostenlose Prüfung starten",
    "fromYourAttorney": "Von Ihrem Markenanwalt",
    "unnamedTrademark": "Unbenannte Marke",
    "insights": {
      "appInProgress": "Anmeldung in Bearbeitung",
      "appInProgressMsg": "Prüfen Sie Ihr Angebot und den Zahlungsstatus, um Ihre Anmeldung voranzubringen.",
      "reportPreparing": "Ihr Bericht ist unterwegs",
      "reportPreparingMsg": "Wir erstellen gerade Ihren Markenbericht und Ihr Angebot. Sie erhalten innerhalb von 24 Stunden eine E-Mail.",
      "quoteReady": "Ihr Angebot ist fertig",
      "quoteReadyMsg": "Ihr von Anwälten bestätigtes Angebot ist fertig. Prüfen Sie es und bezahlen Sie, um Ihre Anmeldung zu starten.",
      "filingInProgress": "Anmeldung läuft",
      "filingInProgressMsg": "Ihre Zahlung ist abgeschlossen. Ihre Markenanmeldung wird für die Einreichung vorbereitet.",
      "paymentPending": "Zahlung ausstehend",
      "paymentPendingMsg": "Ihre Anmeldung ist bereit zur Einreichung. Schließen Sie die Zahlung ab, um fortzufahren.",
      "startJourney": "Starten Sie Ihre Reise",
      "startJourneyMsg": "Erhalten Sie eine kostenlose Markenprüfung und ein Angebot auf unserer Website — ohne Vorauszahlung.",
      "analysisComplete": "Analyse abgeschlossen",
      "analysisCompleteMsg": "Marko hat Ihre Marke analysiert. Prüfen Sie den Bericht auf mögliche Konflikte.",
      "systemOp": "System betriebsbereit",
      "systemOpMsg": "Alle Überwachungssysteme aktiv"
    }
  },
  "status": {
    "inProgress": "In Bearbeitung",
    "quoteRequested": "Bericht wird erstellt",
    "quoteSent": "Angebot bereit",
    "paymentPending": "Zahlung ausstehend",
    "paymentComplete": "Zahlung abgeschlossen",
    "pendingFiling": "Einreichung ausstehend",
    "filingInProgress": "Anmeldung läuft",
    "filed": "Eingereicht",
    "registered": "Eingetragen",
    "completed": "Abgeschlossen",
    "cancelled": "Storniert",
    "refunded": "Erstattet",
    "partiallyRefunded": "Teilweise erstattet"
  },
  "payments": {
    "sectionTitle": "Angebot & Zahlung",
    "sectionSubtitle": "Prüfen Sie Ihr Angebot, unterzeichnen Sie die Erklärung und schließen Sie die Zahlung ab",
    "noApplicationTitle": "Noch keine Anmeldung",
    "noApplicationMsg": "Beginnen Sie mit einer kostenlosen Markenprüfung auf unserer Website. Wir senden Ihnen innerhalb von 24 Stunden einen ausführlichen Bericht und ein Angebot per E-Mail.",
    "startFreeCheck": "Kostenlose Prüfung starten",
    "reportPreparingTitle": "Ihr Bericht wird erstellt",
    "reportPreparingMsg": "Unser Team prüft Ihre Marke und erstellt Ihren ausführlichen Bericht und Ihr Angebot. Wir senden es Ihnen innerhalb von 24 Stunden per E-Mail.",
    "reportForTrademark": "Marke: {{name}}",
    "loadingQuote": "Ihr Angebot wird geladen…",
    "noQuoteTitle": "Ihr Angebot ist noch nicht fertig",
    "noQuoteMsg": "Wir stellen das Angebot für diese Anmeldung noch fertig. Sie erhalten eine E-Mail, sobald es bereit ist. Wenn Sie glauben, dass dies ein Fehler ist, antworten Sie einfach auf eine unserer E-Mails.",
    "quoteTitle": "Ihr Angebot",
    "quoteSubtitle": "Prüfen Sie Ihre Anmeldegebühren und schließen Sie die Zahlung ab",
    "quoteSubtitleConfirmed": "Von unseren Anwälten bestätigt — genau dieser Betrag wird Ihnen berechnet.",
    "breakdown": "Angebotsaufstellung",
    "countries": "Länder",
    "classes": "Klassen",
    "serviceFee": "Servicegebühr",
    "governmentFees": "Amtliche Anmeldegebühren",
    "filingFee": "Markenanmeldung",
    "discount": "Mehrländer-Rabatt",
    "total": "Gesamt",
    "chargedIn": "Abrechnung in {{currency}}",
    "pendingRetry": "Ein früherer Zahlungsversuch ist noch ausstehend. Sie können es erneut versuchen.",
    "attorneyServiceFee": "Honorar des Markenanwalts",
    "quoteDocTitle": "Angebot",
    "dateOfIssue": "Ausstellungsdatum",
    "quoteValidity": "30 Tage gültig",
    "trademarkDetails": "Markendetails",
    "markName": "Marke",
    "markType": "Typ",
    "applicant": "Anmelder",
    "viewFullReport": "Ihren vollständigen Bericht ansehen",
    "hideFullReport": "Ihren vollständigen Bericht ausblenden",
    "reportExpanderHint": "Der Markenbericht, den unser Team für Sie erstellt hat",
    "settingUpPayment": "Sichere Zahlung wird eingerichtet…",
    "paymentRetry": "Erneut versuchen",
    "overlayUnlock": "Haken Sie oben die Erklärung an, um zu bezahlen",
    "overlayUnlockApplicant": "Ergänzen Sie oben die Anmelderdaten, um zu bezahlen",
    "overlayUnlockBoth": "Ergänzen Sie oben die Anmelderdaten und haken Sie die Erklärung an, um zu bezahlen",
    "applicantTbc": "Wird noch bestätigt",
    "applicantDetails": {
      "title": "Anmelderdaten",
      "subtitle": "Die Marke wird auf diesen Namen eingetragen. Das Markenamt benötigt für die Anmeldung den Namen und die Postanschrift des Anmelders.",
      "nameLabel": "Name des Anmelders",
      "namePlaceholder": "Vollständiger rechtlicher Name oder Firmenname",
      "streetLabel": "Straße und Hausnummer",
      "streetPlaceholder": "Beispielstraße 123",
      "cityLabel": "Ort / Stadt",
      "stateLabel": "Bundesland / Region",
      "optional": "(optional)",
      "zipLabel": "Postleitzahl",
      "countryLabel": "Land",
      "saving": "Wird gespeichert…",
      "saved": "Gespeichert",
      "saveError": "Ihre Daten konnten nicht gespeichert werden. Sie werden beim Weitertippen erneut gespeichert."
    },
    "declaration": {
      "loading": "Erklärung wird geladen…",
      "title": "Vollmacht & Erklärung",
      "subtitle": "Erforderlich, bevor wir Ihre Markenanmeldung in Ihrem Namen einreichen können",
      "combined": "Ich bestätige, dass ich berechtigt bin, diese Marke anzumelden, dass die Angaben in dieser Anmeldung wahr und richtig sind, und dass ich MarkoTM als meinen Vertreter für die Einreichung und Verwaltung dieser Anmeldung benenne. Ich akzeptiere die",
      "signedBy": "Unterzeichnet von",
      "signedOn": "am {{date}}",
      "saveError": "Ihre Erklärung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut."
    },
    "report": {
      "title": "Ihr Markenbericht",
      "subtitle": "Von unserem Team erstellt",
      "preparedOn": "Von unserem Team erstellt am {{date}}",
      "sections": {
        "overview": "Überblick",
        "markAssessment": "Bewertung der Marke",
        "registerFindings": "Registerergebnisse",
        "coverageRationale": "Begründung des Schutzumfangs",
        "ourRecommendation": "Unsere Empfehlung",
        "nextSteps": "Nächste Schritte"
      },
      "matchesTitle": "Ergebnisse aus dem Register von IP Australia",
      "matchName": "Marke",
      "matchNumber": "Nummer",
      "matchStatus": "Status",
      "matchClasses": "Klassen"
    }
  },
  "sidebar": {
    "dashboard": "Dashboard",
    "overview": "Übersicht",
    "quoteAndPayment": "Angebot & Zahlung",
    "quoteAndPaymentDesc": "Angebot ansehen und bezahlen",
    "myPortfolio": "Mein Portfolio",
    "viewTrademarks": "Ihre Marken anzeigen",
    "renewals": "Verlängerungen",
    "upcomingDeadlines": "Anstehende Fristen",
    "currentApplication": "Aktuelle Anmeldung",
    "settings": "Einstellungen",
    "portfolio": "Mein Portfolio",
    "newApplication": "Neue Anmeldung",
    "filingProgress": "Anmeldungsfortschritt",
    "documents": "Dokumente",
    "billing": "Abrechnung"
  },
  "header": {
    "notifications": "Benachrichtigungen",
    "profile": "Profil",
    "logout": "Abmelden"
  },
  "attorney": {
    "name": "Ken McInnes",
    "title": "Leiter Markenstrategie",
    "greeting": "Willkommen in Ihrem sicheren IP-Dashboard. Hier können Sie den Fortschritt Ihrer Marke verfolgen und bleiben in jedem Schritt ganz einfach mit Ihrem zugewiesenen Markenanwalt in Kontakt."
  },
  "marko": {
    "analysisComplete": "Ich habe Ihre Marke analysiert! Klicken Sie, um meine Empfehlungen zu sehen.",
    "multiCountry": "Anmeldung in mehreren Ländern? Ich helfe Ihnen bei der Priorisierung.",
    "thinking": "Marko denkt nach...",
    "askMe": "Fragen Sie mich zu Marken",
    "clickToChat": "Klicken zum Chatten →"
  },
  "application": {
    "create": "Anmeldung erstellen",
    "createNew": "Neue Anmeldung erstellen",
    "name": "Anmeldungsname",
    "namePlaceholder": "Geben Sie Ihrer Markenanmeldung einen Namen",
    "nameHelp": "Dies hilft, Ihr IP-Portfolio zu organisieren und den Fortschritt Ihrer Anmeldung zu verfolgen.",
    "delete": "Anmeldung löschen",
    "deleteConfirm": "Sind Sie sicher, dass Sie diese Anmeldung löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    "status": "Anmeldungsstatus",
    "progress": "Fortschritt"
  }
}
